var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef, useCallback } from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import Paginator from '../../Paginator';
import style from './index.module.scss';
import filterProductByName from '../../../utils/filterProductByName';
import underline from '../../../utils/underline';
import instance from '../../../services/httpRequest';
import Loading from '../../Loading';
import oilThumb from '../../../images/oil-thumb-placeholder.png';
import paginatorConfig from '../../../configure/paginatorConfig';
import localesReplacement from '../../../utils/localesReplacement';
import DOMPurify from 'dompurify';
var cx = classnames.bind(style);
export var OilSearch = function (props) {
    var replacements = props.replacements, onProductSelect = props.onProductSelect, selectedWorkshop = props.selectedWorkshop, restore = props.restore, preserved = props.preserved;
    var ref = useRef(null);
    var _a = useState([]), products = _a[0], setProducts = _a[1];
    var _b = useState(''), value = _b[0], setValue = _b[1];
    var _c = useState(0), pageIndex = _c[0], setPageIndex = _c[1];
    var _d = useState(0), mPageIndex = _d[0], setMPageIndex = _d[1];
    var _e = useState(false), isMount = _e[0], setIsMount = _e[1];
    var _f = useState(false), finish = _f[0], setFinish = _f[1];
    var limit = paginatorConfig.LIMIT;
    var controller = new AbortController();
    var memoDate = useCallback(function () {
        selectedWorkshop
            ? _.assign(instance.defaults.headers, { isWorkshopOwner: selectedWorkshop })
            : _.unset(instance.defaults.headers, 'isWorkshopOwner');
        instance
            .get('/products/all', {
            signal: controller.signal,
        })
            .then(function (d) {
            d && setProducts(d.data);
        });
    }, [selectedWorkshop]);
    useEffect(function () {
        return function () {
            controller.abort();
        };
    }, []);
    var mobileProducts = _.take(filterProductByName(products, value), limit * (mPageIndex + 1));
    var onChangeHandler = function (value) {
        setValue(value);
        restore && sessionStorage.setItem('searchOKey', value);
        if (value.length >= 3) {
            setIsMount(true);
            setFinish(false);
            ref.current && clearTimeout(ref.current);
            ref.current = setTimeout(function () {
                products && setIsMount(false);
                setFinish(true);
                var window = globalThis;
                window.dataLayer.push({
                    'event': !_.isEmpty(filterProductByName(products, value)) ? 'oilSearches' : 'detailsUnavailable_oilSearches',
                    'pageType': 'product finder',
                    'searchQuery': value,
                    'searchType': 'oil search',
                    'userType': (sessionStorage.getItem('selectedType') === 'true') ? 'workshop owner' : 'vehicle owner',
                    'countryCode': localStorage.getItem('countryCode')
                });
            }, 1000);
        }
        else {
            setFinish(false);
        }
    };
    var changeIndex = function (index) {
        setPageIndex(index);
    };
    var showMore = function () {
        setMPageIndex(mPageIndex + 1);
    };
    useEffect(function () {
        memoDate();
        setProducts([]);
        setValue(value);
    }, [selectedWorkshop]);
    useEffect(function () {
        var _a;
        if (preserved) {
            setValue((_a = sessionStorage.getItem('searchOKey')) !== null && _a !== void 0 ? _a : '');
            if (!_.isEmpty(products)) {
                setIsMount(true);
                setTimeout(function () {
                    setIsMount(false);
                }, 1000);
            }
        }
    }, [preserved, products]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: cx('search-input') }, { children: [_jsx("input", { type: 'text', value: value, onChange: function (ev) { return onChangeHandler(ev.target.value); }, placeholder: localesReplacement(replacements, 'Search by the oil name') }, void 0), !!value.length && (_jsx("i", { className: cx('remove'), onClick: function () {
                            setValue('');
                            restore && sessionStorage.removeItem('searchOKey');
                        } }, void 0)), _jsx("i", { className: cx('voice') }, void 0)] }), void 0), !isMount ? (_jsx(_Fragment, { children: !_.isEmpty(filterProductByName(products, value)) ? (_jsxs("div", __assign({ className: cx('result', {
                        'with-paginator': filterProductByName(products, value) &&
                            Math.ceil(filterProductByName(products, value).length / limit) > 1,
                    }) }, { children: [_jsx("div", __assign({ className: cx('result-heading') }, { children: _jsxs("ul", { children: [_jsx("li", { children: localesReplacement(replacements, 'Picture') }, void 0), _jsx("li", { children: localesReplacement(replacements, 'Oil name') }, void 0), _jsx("li", { children: localesReplacement(replacements, 'Description') }, void 0), _jsx("li", {}, void 0)] }, void 0) }), void 0), _.chain(filterProductByName(products, value))
                            .chunk(limit)
                            .get(pageIndex)
                            .map(function (product) { return (_jsx("div", __assign({ className: cx('result-row', 'desktop', 'product-trigger'), onClick: function () {
                                return onProductSelect && onProductSelect(product['id'], product['name']);
                            } }, { children: _jsxs("ul", { children: [_jsx("li", { children: _jsx("img", { src: product['packartUrl']
                                                ? product['packartUrl']
                                                : oilThumb }, void 0) }, void 0), _jsx("li", { dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(underline(product['name'], value)),
                                        } }, void 0), _jsx("li", { dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(product['description']),
                                        } }, void 0), _jsxs("li", { children: [_jsx("span", { className: cx('expend') }, void 0), _jsx("button", __assign({ className: cx('recommonended-btn') }, { children: localesReplacement(replacements, 'View product page') }), void 0)] }, void 0)] }, void 0) }), product.id)); })
                            .value(), _.map(mobileProducts, function (product, index) { return (_jsx("div", __assign({ className: cx('result-row', 'mobile', 'product-trigger'), onClick: function () {
                                return onProductSelect && onProductSelect(product['id'], product['name']);
                            } }, { children: _jsxs("ul", { children: [_jsx("li", { children: _jsx("img", { src: product['packartUrl']
                                                ? product['packartUrl']
                                                : oilThumb }, void 0) }, void 0), _jsx("li", { dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(underline(product['name'], value)),
                                        } }, void 0), _jsx("li", { children: _jsx("button", __assign({ className: cx('recommonended-btn') }, { children: localesReplacement(replacements, 'View product page') }), void 0) }, void 0)] }, void 0) }), index)); }), !!filterProductByName(products, value) &&
                            mobileProducts.length <
                                filterProductByName(products, value).length && (_jsx("div", __assign({ className: cx('btn-show-more') }, { children: _jsx("span", __assign({ onClick: showMore }, { children: localesReplacement(replacements, 'Show more') }), void 0) }), void 0)), !!products && (_jsx(Paginator, { index: pageIndex, changeIndexHandler: changeIndex, total: Math.ceil(filterProductByName(products, value).length / limit) }, void 0))] }), void 0)) : (finish &&
                    _.trim(value).length >= 3 && (_jsx("div", __assign({ className: 'no-match' }, { children: _jsx("div", __assign({ className: 'no-found-text no-oil-text' }, { children: _jsxs("p", { children: [localesReplacement(replacements, 'No results found for'), _jsx("strong", { children: _.trim(value) }, void 0)] }, void 0) }), void 0) }), void 0))) }, void 0)) : (_jsx(Loading, {}, void 0))] }, void 0));
};
export default OilSearch;
